import { render, staticRenderFns } from "./OrgstuctTree.vue?vue&type=template&id=5ba681b3"
import script from "./OrgstuctTree.vue?vue&type=script&lang=js"
export * from "./OrgstuctTree.vue?vue&type=script&lang=js"
import style0 from "./OrgstuctTree.vue?vue&type=style&index=0&id=5ba681b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports